import {
  GetCollaboratorsHistoryProfessionalDataResponse,
  AddCollaboratorsHistoryProfessionalDataRequest,
  UpdateCollaboratorsHistoryProfessionalDataRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryProfessionalDataService = {
  async get(
    collaboratorId: number,
    signal?: AbortSignal,
  ): Promise<GetCollaboratorsHistoryProfessionalDataResponse> {
    const response =
      await httpClient.get<GetCollaboratorsHistoryProfessionalDataResponse>(
        `v1/collaborators/${collaboratorId}/history/professional-data`,
        { signal },
      );
    return response;
  },

  async add(
    collaboratorId: number,
    body: AddCollaboratorsHistoryProfessionalDataRequest,
  ): Promise<void> {
    await httpClient.post<AddCollaboratorsHistoryProfessionalDataRequest, void>(
      `v1/collaborators/${collaboratorId}/history/professional-data`,
      body,
    );
  },

  async update(
    collaboratorId: number,
    id: number,
    body: UpdateCollaboratorsHistoryProfessionalDataRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/professional-data/${id}`,
      body,
    );
  },

  async delete(collaboratorId: number, id: number): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/professional-data/${id}`,
    );
  },
};

export default CollaboratorsHistoryProfessionalDataService;
